var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full"},[_vm._t("top"),(_vm.title)?_c('h2',[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.description)?_c('p',{staticClass:"full__description"},[_vm._v(" "+_vm._s(_vm.description)+" ")]):_vm._e(),_vm._t("bottom")],2)}
var staticRenderFns = []

export { render, staticRenderFns }